import React from 'react';
import ReactDOM from 'react-dom/client';
import SectionHolder from './components/section-holder/index.js';
import Title from './components/title/index.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<>
<Title></Title>
<SectionHolder></SectionHolder>
</>);
